import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import LoadingSpinner from '../loadingSpinner/';
import Message from '../message/';
import { dateTextFormat } from '../../common';
// import Line from './line';

// const getLeagueKeys = memoizee((league) => _.keysIn(league));

@inject('accountStore', 'dictStore')
@observer
export default class History extends Component {

	componentDidMount() {
		this.props.accountStore.initPage('history');
	}

  handleCloseError() {
  	this.props.accountStore.HistoryPage.clearResult();
  }

	componentWillUnmount() {
    this.props.accountStore.clear('HistoryPage');
  }

    
	render() {

		if (!this.props.accountStore.HistoryPage) return false;

		const {isLoading, result} = this.props.accountStore.HistoryPage;
		const {getLang} = this.props.dictStore;

		return (
			isLoading ? 
			<div>
				<LoadingSpinner />
			</div> :
				<Fragment>
					<h1>{getLang('ACCOUNT_HISTORY')}</h1>
			    <Filter />
					{result.status ?  <Message text={result.text} type={result.type} onClose={this.handleCloseError}/> : ''}
			    <List />
		    </Fragment>
		)
	}
}

@inject('accountStore', 'dictStore')
@observer
class Filter extends Component {

	handleClick = () => {
		this.props.accountStore.HistoryPage.loadData();
	}

	selectDate = (e) => {
		this.props.accountStore.HistoryPage.selectDate(e.target.value);
	}

	render() {

		const {filter, wait, date} = this.props.accountStore.HistoryPage;
		const {getLang} = this.props.dictStore;

		if (!filter) return false;

		return(
			<div className="account-history-menu clearfix">
        <div className="row">
            <div className="row-item">
                <label>
                    <select onChange={this.selectDate}>
                    	{filter.date.map(value => 
	                      <option key={value} value={value} selected={value == date}>
	                        {getLang(`ACCOUNT_HISTORY_DATE_${value}`)}
												</option>
											)}
                    </select>
                </label>
            </div>
            <div className="row-item buttons">
                <button type="button" className={`flat_button ${wait ? 'wait' : ''}`} disabled={wait} onClick={this.handleClick}>{getLang('SHOW')}</button>
            </div>
        </div>
    </div>
		)
	}
}

@inject('accountStore', 'dictStore')
@observer
class List extends Component {

	handleCancel = (id) => {
		this.props.accountStore.HistoryPage.cancel(id);
	}

	render() {

		const {data, error, result} = this.props.accountStore.HistoryPage;
		const {getLang} = this.props.dictStore;

		if (!data || data.length === 0) return (
			<div className="account-history-no">
        {getLang('NO_HISTORY')}
    	</div>
		)

		return(
			<div>
				{data.map( el => 
					<div key={el.id} className="account-history-item clearfix">
					    <div className={`account-history-item-status fl_r ${el.status == 1 || el.status == 2 ? 'account-history-item-status-success' : ''}`}>
					    	{el.status >= 0 ? getLang('ACCOUNT_HISTORY_STATUS_' + el.status) : ''}
					    	{el.cancel_reason}
					    </div>
					    <div className="account-history-item-date" title={`${getLang('DATE')}: ${el.date}`}>{dateTextFormat(el.date)}</div>
					    <div className="account-history-item-line clearfix">
					    	{el.allow_cancel == 1 ? 
					    		<div className="account-history-item-cancel fl_r">
					    			<a className="account-history-item-cancel-link" onClick={() => {this.handleCancel(el.id)}} ></a>
					    		</div> : '' }
					    	{el.text}
					    </div>
					</div>
				)}	
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/account/history.js